import {http} from '@/axios'

export default function ({vacancyId, messenger}) {
  return http.post(`/api/vacancy/${vacancyId}/send-resume`, {
    messanger: messenger
  })
}
